import { Component, Inject, OnInit} from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoaderService } from '../../shared/loader/loader.service';
import { StatusConstant } from '../status/status-constant';

@Component({
  selector: 'app-sendEmailNotification',
  templateUrl: './sendEmailNotification.component.html',
  styleUrls: ['./sendEmailNotification.component.scss'] 
})

export class SendEmailNotificationComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;    
  formDialog: FormGroup; 
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;
  statusList:any=[]=[];
  selectedtouchStatusID:number=0;
  ShowNoRecordFoundStatus:boolean=false;
  repeatTaskEmail:string="";

  taskDetailList: any = [] = [];
  getTaskAssignedEntityInDetails: any = [] = [];
  getTaskAttachedEntityInDetails: any = [] = [];
  entityTypeAssignee: number = 2;
  taskAssignedEntity: any = [] = [];
  taskAttachedEntity: any = [] = [];
  TaskReminderTaskId: number = 0;
  entityTypeAttached: any;
  SubmitColumnsButton: boolean = false;

  constructor(public dialogRef: MatDialogRef<SendEmailNotificationComponent>,  
    private formBuilder: FormBuilder,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private coreService: CoreService,private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,private loaderService: LoaderService,private statusConstant: StatusConstant,) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
  }  
  
  ngOnInit(): void {    
    this.repeatTaskEmail = "";
    this.TaskReminderTaskId = this.data.taskListID.taskId;
    this.getTaskDetailByID(this.data.taskListID.taskId);
   }     
       
   getTaskDetailByID(taskId) {
    this.loaderService.show();
    var ReqModel = {
      taskID: taskId,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.coreService.getTaskDetailByID(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess && this.responseHolder.data != null) {
          this.taskDetailList = response.data;

          var data = JSON.parse(this.taskDetailList.notifyData);

          if (data != null) {
            this.repeatTaskEmail = data.NotifyEmails;
            this.SubmitColumnsButton = true;
            this.loaderService.hide();
            return;
          }
          this.getTaskAssignedEntityInDetails = this.taskDetailList.taskAssignedEntity;
          this.getTaskAttachedEntityInDetails = this.taskDetailList.taskAttachedEntity;

          this.entityTypeAssignee = this.taskDetailList.entityTypeAssignee;
          this.entityTypeAttached = this.taskDetailList.entityTypeAttached;


          if (this.getTaskAssignedEntityInDetails.length > 0) {
            // Contact-1,Role-2,Email-3,User-4,RelationShip-5
            // Added For Contact
            if (this.entityTypeAssignee == 1) {
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAssignedEntityInDetails[i].assigneeEmail != "") {
                  this.repeatTaskEmail += this.getTaskAssignedEntityInDetails[i].assigneeEmail + ',';
                }
              }
            }

            // Added For Email
            if (this.entityTypeAssignee == 3) {
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAssignedEntityInDetails[i].email != "") {
                  this.repeatTaskEmail += this.getTaskAssignedEntityInDetails[i].email + ',';
                }
              }
            }

            // Added For User
            if (this.entityTypeAssignee == 4) {
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAssignedEntityInDetails[i].assigneeEmail != "") {
                  this.repeatTaskEmail += this.getTaskAssignedEntityInDetails[i].assigneeEmail + ',';
                }
              }
            }
            if (this.entityTypeAssignee == 5) {
              for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAssignedEntityInDetails[i].assigneeEmail != "") {
                  this.repeatTaskEmail += this.getTaskAssignedEntityInDetails[i].assigneeEmail + ',';
                }
              }
            }
          }

          if (this.getTaskAttachedEntityInDetails.length > 0) {
            // Core-1,Contact-2,Company-3
            // Added For Core
            if (this.entityTypeAttached == 1) {
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAttachedEntityInDetails[i].attachedEntityEmail != "") {
                  this.repeatTaskEmail += this.getTaskAttachedEntityInDetails[i].attachedEntityEmail + ',';
                }
              }
            }

            // Added For Contact
            if (this.entityTypeAttached == 2) {
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAttachedEntityInDetails[i].attachedEntityEmail != "") {
                  this.repeatTaskEmail += this.getTaskAttachedEntityInDetails[i].attachedEntityEmail + ',';
                }
              }
            }

            // Added For Company
            if (this.entityTypeAttached == 3) {
              for (var i = 0, len = this.getTaskAttachedEntityInDetails.length; i < len; ++i) {
                if (this.getTaskAttachedEntityInDetails[i].attachedEntityEmail != "") {
                  this.repeatTaskEmail += this.getTaskAttachedEntityInDetails[i].attachedEntityEmail + ',';
                }
              }
            }
          }

          this.repeatTaskEmail = this.repeatTaskEmail.replace(/,(\s+)?$/, '');
          this.SubmitColumnsButton = true;
          this.loaderService.hide();
        }
        else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

   onSendManualTaskReminder() {
    if (this.repeatTaskEmail == "") {
      this.toastr.warning('Please add email id.', '', {
        timeOut: 3000,
      });
      return;
    }
    var check = this.repeatTaskEmail;
    var newcheck: any = [];
    newcheck = check.split(',');
    for (var i = 0; i < newcheck.length; i++) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var checkemail = re.test(String(newcheck[i]).toLowerCase());
      if (checkemail == true) {
      } else {
        this.toastr.warning('Please provide valid email.', '', {
          timeOut: 3000,
        });
        return;
      }
    }
    var reqModel = {
      taskID: this.TaskReminderTaskId,
      emails: this.repeatTaskEmail,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.SubmitColumnsButton = false;
    this.loaderService.show();
    this.coreService.SendManualTaskReminderService(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.loaderService.hide();
          this.toastr.success('Task reminder send successfully.', '', {
            timeOut: 3000,
          });
          this.closeSendReminder();
        } else {
          this.loaderService.hide();
          this.toastr.error('Task reminder failed.', '', {
            timeOut: 3000,
          });
          this.closeSendReminder();
        }
      } else {
        this.loaderService.hide();
        this.toastr.error('Task reminder failed.', '', {
          timeOut: 3000,
        });
        this.closeSendReminder();
      }
    });
  }


   closeSendReminder() {
    this.dialogRef.close();
  }

 

  

}
